export let sampleHandle = [{
    value: "true",
    label: "客户领回",
  },
  {
    value: "false",
    label: "承检方处置",
  },
];
export let stateOptions = ["固体", "半固体", "液体", "气体", "粉末", "颗粒"];
export let packOptions = ["玻璃瓶", "塑料瓶", "塑料袋", "无菌袋"];
export let storageOptions = ["常温", "冷藏", "冷冻", "避光"];
export let deviateOptions = ["是", "否"];